import { PrivacyPolicy } from './components';
import { IModule } from 'core/rootInterfaces/root.interface';

export const privacyPolicyModule: IModule = {
  moduleName: 'privacyPolicy',
  path: '/privacy-policy',
  component: PrivacyPolicy,
  reducer: null,
};
